import FormData from 'form-data';
import React from 'react';
import config from '../../config/app';

export default function withUpload(WrappedComponent) {
  return class UploadFile extends React.Component {
    state = null;

    uploadFile = file => {
      const {api_file_brand} = config;
      // Upload the image using the fetch and FormData APIs
      let formData = new FormData();
      // Assume "photo" is the name of the form field the server expects
      formData.append('data', file);
      // performAction(this.props.action, this.props.getPermissions);
      return fetch(api_file_brand, {
        method: 'POST',
        body: formData,
        header: {
          'content-type': 'multipart/form-data',
        },
      });
    };

    render() {
      return <WrappedComponent {...this.props} uploadFile={this.uploadFile} />;
    }
  };
}
